import { getPortalFontCssFamily } from '../guestPortal/portalFonts';
import defaultCover from '../../assets/images/guest-menu-hero.jpg';

export const DEFAULT_MENU_SETTINGS = {
  restaurant_name: '', tagline: 'Good food. Good company.', ordering_open: true,
  paused_message: 'Online ordering is paused. Please order with our team.',
  logo: null, logo_size: 100, logo_position_x: 50, logo_offset_y: 0, background_image: null,
  background_overlay_colour: '#000000', background_overlay_opacity: '0.65',
  button_colour: '#d9b36c', button_text_colour: '#141312', background_colour: '#ffffff',
  show_product_images: true, card_colour: '#121110', font_family: 'figtree', layout: 'cards',
};

export function contrastText(hex) {
  const rgb = String(hex).match(/^#([0-9a-f]{6})$/i)?.[1];
  if (!rgb) return '#141312';
  if (colourContrast(hex, '#141312') >= 4.5) return '#141312';
  return colourContrast(hex, '#ffffff') >= 4.5 ? '#ffffff' : '#000000';
}

export function menuTheme(settings = {}) {
  const value = { ...DEFAULT_MENU_SETTINGS, ...settings };
  return {
    '--guest-accent': value.button_colour,
    '--guest-button-text': colourContrast(value.button_colour, value.button_text_colour) >= 4.5 ? value.button_text_colour : contrastText(value.button_colour),
    '--guest-bg': value.background_colour, '--guest-ink': contrastText(value.background_colour),
    '--guest-muted': contrastText(value.background_colour) === '#ffffff' ? '#b9b9b9' : '#797570',
    '--guest-card': value.card_colour, '--guest-card-text': contrastText(value.card_colour),
    '--guest-cover': `url(${JSON.stringify(value.background_image || defaultCover)})`,
    '--guest-overlay': value.background_overlay_colour, '--guest-overlay-opacity': value.background_overlay_opacity,
    '--guest-surface': contrastText(value.background_colour) === '#ffffff' ? '#ffffff12' : '#00000006',
    '--guest-line': contrastText(value.background_colour) === '#ffffff' ? '#ffffff26' : '#0000001a',
    '--guest-logo-x': `${value.logo_position_x}%`, '--guest-logo-shift-x': `${-value.logo_position_x}%`, '--guest-logo-y': `${value.logo_offset_y}px`,
    '--guest-font': getPortalFontCssFamily(value.font_family), '--guest-logo-size': `${value.logo_size}px`,
  };
}


export function colourContrast(first,second) {
  const luminance=hex=>{
    const values=String(hex).match(/^#([0-9a-f]{6})$/i)?.[1];
    if(!values)return 0;
    const rgb=[0,2,4].map(index=>{const value=parseInt(values.slice(index,index+2),16)/255;return value<=0.04045?value/12.92:((value+0.055)/1.055)**2.4;});
    return rgb[0]*0.2126+rgb[1]*0.7152+rgb[2]*0.0722;
  };
  const a=luminance(first),b=luminance(second);
  return (Math.max(a,b)+0.05)/(Math.min(a,b)+0.05);
}
